<template>
  <div class="modal-content">
    <v-flex
      xs12
      v-if="
        (showSkeleton ||
          (saleUninitiated && !$route.query.listar_apresentacoes)) &&
          !showQueue &&
          !showPreSale
      "
    >
      <skeleton />
    </v-flex>
    <v-flex
      xs12
      v-if="
        !showDefault &&
          sectorMap &&
          sectorMap.length > 0 &&
          (!$route.query.listar_apresentacoes ||
            !filteredPresentations.length) &&
          !showQueue &&
          !showPreSale
      "
      :class="selectedSeat || selectedInfo ? 'md8' : ''"
    >
      <SeatMap />
    </v-flex>
    <v-flex
      xs12
      md4
      v-if="
        !showDefault &&
          selectedSeat &&
          !selectedSeat.reserved &&
          !showQueue &&
          !showPreSale
      "
    >
      <ProductsSector />
    </v-flex>
    <v-flex
      xs12
      md4
      v-if="
        !showDefault &&
          selectedInfo &&
          !showSkeleton &&
          !showQueue &&
          !showPreSale
      "
    >
      <Info />
    </v-flex>
    <v-flex
      xs12
      md4
      v-if="!showDefault && selectedSeat && selectedSeat.reserved"
    >
      <EditProductsSector />
    </v-flex>
    <v-flex
      :style="
        currentStep === 5 &&
        orderData &&
        orderData.orderData &&
        orderData.orderData.gamification
          ? 'height: 100% !important'
          : ''
      "
      v-if="!orderPdvExpired && !showPreSale && !showQueue"
      xs12
      md6
    >
      <Map
        v-if="currentStep === 1 && showDefault && !showSkeleton && eventMapUrl"
        :mapUrl="eventMapUrl"
      />
      <Summary
        v-else-if="
          showDefault &&
            !showSkeleton &&
            !printTickets &&
            !saleUninitiated &&
            !$route.query.listar_apresentacoes
        "
      />
      <Gamification
        v-if="
          currentStep === 5 &&
            orderData &&
            orderData.orderData &&
            orderData.orderData.gamification
        "
      />
    </v-flex>
    <v-flex
      xs12
      :class="
        printTickets && currentComponent.name === 'Confirmation'
          ? 'md12'
          : 'md6'
      "
      v-if="
        showDefault &&
          !showSkeleton &&
          !orderPdvExpired &&
          !showPreSale &&
          !showQueue &&
          !saleUninitiated &&
          (!$route.query.listar_apresentacoes || !filteredPresentations.length)
      "
    >
      <keep-alive>
        <component
          v-bind:is="currentComponent.name"
          v-bind="currentComponent.props"
        ></component>
      </keep-alive>
    </v-flex>

    <v-flex
      v-if="
        currentStep === 1 &&
          $route.query.listar_apresentacoes &&
          !showSkeleton &&
          filteredPresentations.length
      "
      class="xs12"
    >
      <choose-presentation :filteredPresentations="filteredPresentations" />
    </v-flex>
    <v-flex
      xs12
      v-if="
        currentStep === 1 &&
          cartProducts.length &&
          !selectedSeat &&
          !saleUninitiated
      "
    >
      <v-card>
        <v-divider></v-divider>
        <products-pre-order />
      </v-card>
    </v-flex>

    <v-flex v-if="showPreSale">
      <v-layout>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <pre-sale />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex v-else-if="showQueue && queue">
      <v-layout :row="!mobile ? true : false" :column="mobile ? true : false">
        <v-flex xs12 sm12 md6 lg6 xl6>
          <queue />
        </v-flex>
        <v-flex xs12 sm12 md6 lg6 xl6>
          <queue-information />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="orderPdvExpired">
      <v-layout>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <order-expired />
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
import moment from 'moment';
import Products from '../Product/Products';
import ProductsSector from '../Product/ProductsSector';
import EditProductsSector from '../Product/EditProductsSector';
import Queue from '../Queue/Queue.vue';
import Summary from '../Summary/Summary';
import Map from '../Map/Map';
import SeatMap from '../Map/SeatMap';
import Delivery from '../Delivery/Delivery';
import Infos from '../Infos/Infos';
import Nomination from '../Nomination/Nomination';
import Payment from '../Payment/Payment';
import Confirmation from '../Confirmation/Confirmation';
import ProductsPreOrder from '../Product/ProductsPreOrder';
import Info from '../Product/Info';
import Skeleton from '../Modal/Skeleton';
import Gamification from '../Gamification/Gamification.vue';
import QueueInformation from '../Queue/QueueInformation.vue';
import OrderExpired from './OrderExpired.vue';
import PreSale from '../preSale/Index.vue';
import { mapGetters } from 'vuex';
import ChoosePresentation from '../Product/ChoosePresentation.vue';

export default {
  components: {
    Queue,
    Products,
    Skeleton,
    PreSale,
    Info,
    ProductsPreOrder,
    ProductsSector,
    EditProductsSector,
    Summary,
    Map,
    Delivery,
    Infos,
    Nomination,
    Payment,
    Confirmation,
    SeatMap,
    Gamification,
    QueueInformation,
    OrderExpired,
    ChoosePresentation,
  },
  computed: {
    ...mapGetters(['showPreSale', 'saleUninitiated', 'eventDetails']),
    loading() {
      return this.$store.getters.loading;
    },
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true;
        case 'sm':
          return true;
      }
    },
    showSkeleton() {
      return this.$store.getters.showSkeleton;
    },
    printTickets() {
      return this.$store.getters.printTickets;
    },
    showQueue() {
      return this.$store.getters.showQueue;
    },
    products() {
      return this.$store.getters.products;
    },
    orderData() {
      return this.$store.getters.orderData;
    },
    orderPdvData() {
      return this.$store.getters.orderPdvData;
    },
    queue() {
      return this.$store.getters.queue;
    },
    selectedInfo() {
      return this.$store.getters.selectedInfo;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    sectorMap() {
      return this.$store.getters.sectorMap;
    },
    selectedSector() {
      return this.$store.getters.selectedSector;
    },
    showDefault() {
      return this.$store.getters.showDefault;
    },
    currentStep() {
      return this.$store.getters.currentStep;
    },
    selectedSeat() {
      return this.$store.getters.selectedSeat;
    },
    eventMapUrl() {
      return this.$store.getters.eventMapUrl;
    },
    currentComponent() {
      if (this.$route.name !== 'totem')
        switch (this.currentStep) {
          case 1:
            return {
              name: 'Products',
              props: { products: this.products },
            };
          case 2:
            return {
              name: 'Delivery',
              props: {},
            };
          case 3:
            return {
              name: 'Infos',
              props: {},
            };
          case 4:
            return {
              name: 'Payment',
              props: {},
            };
          case 5:
            return {
              name: 'Confirmation',
              props: {},
            };
          default:
            return {
              name: 'Products',
              props: { products: this.products },
            };
        }
      else
        switch (this.currentStep) {
          case 1:
            return {
              name: 'Products',
              props: { products: this.products },
            };
          case 2:
            return {
              name: 'Payment',
              props: {},
            };
          case 3:
            return {
              name: 'Confirmation',
              props: {},
            };
          default:
            return {
              name: 'Products',
              props: { products: this.products },
            };
        }
    },

    filteredPresentations() {
      if (
        this.eventDetails &&
        this.eventDetails.relacionados &&
        this.eventDetails.relacionados.length
      ) {
        let filteredPresentations = this.eventDetails.relacionados.filter(
          presentation => {
            let formattedEndDate = this.$moment.unix(
              presentation.data_encerramento_ts
            );

            let today = this.$moment();

            return !formattedEndDate.isBefore(today);
          }
        );

        console.log('filteredPresentations', filteredPresentations);
        return filteredPresentations;
      }

      return [];
    },

    orderPdvExpired() {
      if (
        this.$route.name === 'commissioner' &&
        this.orderPdvData &&
        this.orderPdvData.data_expiracao_pedido
      )
        return moment().isAfter(this.orderPdvData.data_expiracao_pedido);
      else return false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/modal/modalContent.styl'
</style>
